import { useState, useEffect } from 'react';
import { find, isString } from 'lodash/fp';

export function useMutationObserver(selector) {
    const [node, setNode] = useState(isString(selector) ? null : selector);

    useEffect(() => {
        let hit = null;
        if (selector && !node) {
            hit = document.querySelector(selector);

            if (hit) {
                setNode(hit);
            }

            let mutationObserver = null;
            if (!hit) {
                mutationObserver = new MutationObserver((mutationList) => {
                    for (const mutation of mutationList) {
                        const { addedNodes } = mutation;
                        hit = find((node) => node.querySelector?.(selector), addedNodes);
                        if (hit) {
                            setNode(hit.querySelector(selector));
                            mutationObserver.disconnect();
                        }
                    }
                });

                mutationObserver.observe(document.body, {
                    subtree: true,
                    childList: true
                });
                return () => mutationObserver?.disconnect();
            }
        }
    }, [selector, node]);

    return node;
}
